<template>
  <div class="login-page">
    <h2>欢迎来到简单简历</h2>
    <el-form ref="loginForm" :model="loginData" :rules="loginRules">
      <el-form-item prop="email" label="邮箱">
        <el-input placeholder="请输入邮箱地址" v-model="loginData.email">
        </el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <template #label>
          <span>密码</span>
        </template>
        <el-input placeholder="请输入密码" type="password" v-model="loginData.password">
        </el-input>
      </el-form-item>
      <el-form-item prop="captcha" label="验证码" class="captcha-container">
        <el-input placeholder="请输入验证码" v-model="loginData.captcha">
        </el-input>
        <div id="captcha-afterload" v-html="captchaData" class="captcha-container" @click="generateCaptcha">
        </div>
      </el-form-item>
      <div class="bottom-section">
        <el-button type="primary" @click="userLogin">登录</el-button>
      </div>
    </el-form>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from 'vue'
import { useStore } from '../store/index'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import { RespData } from '../store/respTypes'
export interface FormInstance {
  validate: (cb: (result: boolean) => void) => void,
  resetFields: () => void
}
export default defineComponent({
  name: 'Login',
  props: {
    msg: String,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const loginForm = ref<null | FormInstance>(null)
    const loginData = reactive({
      email: '',
      password: '',
      captcha: ''
    })
    const captchaData = ref('')
    const loginRules = {
      email: [
        { required: true, message: '邮箱地址不能为空', trigger: 'blur' },
        { pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, message: '邮箱格式不正确', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '密码不能为空', trigger: 'blur' },
        { min: 6, message: '密码至少6位', trigger: 'blur' }
      ],
      captcha: [
        { required: true, message: '验证码不能为空', trigger: 'blur' },
        { len: 4, message: '验证码应该为 4 位', trigger: 'blur' }
      ]
    }
    const generateCaptcha = () => {
      axios.get<RespData<string>>('/api/captcha').then(({ data }) => {
        captchaData.value = data.data
      })
    }
    onMounted(() => {
      generateCaptcha()
    })
     const userLogin = () => {
      loginForm.value?.validate((result) => {
        if (result) {
          const payload = {
            email: loginData.email,
            password: loginData.password,
            captcha: loginData.captcha
          }
          store.dispatch('loginAndFetch', { data: payload }).then(() => {
            ElMessage({
              type: 'success',
              message: '登录成功 2秒后跳转首页'
            })
            setTimeout(() => {
              router.push('/')
            }, 2000)
          }).finally(() => {
            loginForm.value?.resetFields()
          })
        } else {
          return false
        }
      })
    }
    return {
      loginForm,
      loginData,
      loginRules,
      captchaData,
      userLogin,
      generateCaptcha
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.login-page {
  width: 400px;
  margin: 100px auto;
}
.bottom-section {
  button {
    width: 100%;
  }
}
</style>
